import script from "./PaypalTimeout.vue?vue&type=script&lang=ts&setup=true"
export * from "./PaypalTimeout.vue?vue&type=script&lang=ts&setup=true"

import "./PaypalTimeout.vue?vue&type=style&index=0&id=4968ed19&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4968ed19"]])

export default __exports__